// extracted by mini-css-extract-plugin
module.exports = {"logoWrapper":"NavbarLogoWrapper_logoWrapper__rxO10"};